var i = Object.defineProperty;
var n = (a, e, s) => e in a ? i(a, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : a[e] = s;
var o = (a, e, s) => n(a, typeof e != "symbol" ? e + "" : e, s);
import { isEmpty as p } from "lodash-es";
import { A as c } from "../../../api-CZJ4bXCT.mjs";
const r = class r {
  constructor(e) {
    /**
     * api request adapter object
     */
    o(this, "adapter");
    this.adapter = new c({
      baseURL: e,
      responseType: "json",
      headers: {
        timeout: 60 * 10 * 1e3,
        "content-type": "application/json",
        accept: "application/json"
      }
    }), this.getAddressDetails = this.getAddressDetails.bind(this), this.getAddressesLookup = this.getAddressesLookup.bind(this);
  }
  /**
   * Rertrieve a list of addresses
   * @param queryString string to search
   */
  async getAddressesLookup(e) {
    return (await this.adapter.getValue(e)).data.records.filter((t) => !p(t.id)).map((t) => ({
      label: t.addressLine,
      value: t.id
    }));
  }
  /**
   * Retrieve the full details of the address
   * @param id unique id for the address
   */
  async getAddressDetails(e, s) {
    const t = `${r.searchUri}/${encodeURIComponent(e)}?country=${s}`;
    return (await this.adapter.getValue(t)).data;
  }
};
/**
 * Static constant of search endpoint
 */
o(r, "searchUri", "/adapter/v1/cwp/address/addresses");
let d = r;
export {
  d as default
};
